/* Functions that have something to do with nodes */

const calcBBox = (g) => {
  /* calculates appropriate width/height for foreignObject based on the node's content */
  let container = g.querySelector('div.node-container')
  let nodeCopy = container.cloneNode(true)
  document.body.appendChild(nodeCopy)
  nodeCopy.style.width = 'auto'
  nodeCopy.style.height = 'auto'
  nodeCopy.style.position = 'absolute'
  let width = nodeCopy.clientWidth 
  let height = nodeCopy.clientHeight
  document.body.removeChild(nodeCopy)
  return {width, height}
}

const getTextBoxSize = (text, fontFamily, fontSize) => {
  fontFamily = fontFamily || 'Roboto'
  fontSize = fontSize || '15px'
  const textNode = document.createElement('span')
  document.body.appendChild(textNode)
  textNode.style.font = fontFamily
  textNode.style.fontSize = fontSize
  textNode.style.width = 'auto'
  textNode.style.height = 'auto'
  textNode.style.position = 'absolute'
  textNode.innerText = text

  let width = Math.ceil(textNode.clientWidth) + 'px'
  let height = Math.ceil(textNode.clientHeight) + 'px'
  document.body.removeChild(textNode)
  return { width, height }
}


export {
  calcBBox, 
  getTextBoxSize,
}